<!--Menu Bar-->
<div class="lock-to-top TopBarGrid" style="background-color: #ffffff">
	<div class="SearchGrid">
		<label>School:</label>
		<caass-schoolselector [ShowAll]="SchoolSelectShowAll" [lstExtraOptions]="lstExtraOptions" [Disabled]="IsLoading() == true"> </caass-schoolselector>

		<label>Person Type:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="PersonTypeID" [(ngModel)]="PersonTypeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstPersonType" [ngValue]="o.PersonTypeID">
				{{ o.PersonTypeDesc }}
			</option>
		</select>

		<label>Active:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="Active" [(ngModel)]="Active">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstActive" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>

		<label>Search For:</label>
		<div class="SearchGrid">
			<input
				type="text"
				class="form-control"
				[(ngModel)]="Filter"
				(keydown)="onPersonFilterKeyDown($event)"
				placeholder="Search by name, Student ID, Staff ID, Username, Staff Title or Barcode"
			/>
			<button [disabled]="IsLoading() == true" id="SearchButton" class="btn btn-primary" style="margin: 0px; width: fit-content" (click)="onSearch()">
				Search
			</button>
		</div>
	</div>

	<div class="CenterText">
		<label>Columns to Display:</label>

		<!-- <p-listbox [options]="lstColumnOptions" [(ngModel)]="SelectedColumnOptions" [multiple]="true" [checkbox]="true" optionLabel="Field">
			<ng-template let-ColumnOption pTemplate="item">
				<div class="ColumnOption">
					{{ColumnOption.Field}}
				</div>
			</ng-template>
		</p-listbox> -->

		<div class="ColGrid">
			<div *ngFor="let o of lstColumnOptions" class="ColOption">
				<input [id]="o.Header" class="form-control CHK" type="checkbox" [(ngModel)]="o.Selected" />
				<label [for]="o.Header">{{ o.Header }}</label>
			</div>
		</div>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPerson"
		dataKey="PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->
				<th *ngIf="IsSelected('Photo')" class="IMGCol">
					<p-columnFilter field="HasImageDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHasImageDesc
								[ngModel]="value"
								[options]="lstHasImageDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--FirstName-->
				<th *ngIf="IsSelected('FirstName')">
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th *ngIf="IsSelected('LastName')">
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th *ngIf="IsSelected('SchoolName')">
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SchoolNumber-->
				<th *ngIf="IsSelected('SchoolNumber')">
					<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolID-->
				<th *ngIf="IsSelected('SchoolID')">
					<p-columnFilter type="text" field="SchoolID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PersonTypeDesc-->
				<th *ngIf="IsSelected('PersonTypeDesc')">
					<p-columnFilter field="PersonTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPersonTypeDesc
								[ngModel]="value"
								[options]="lstPersonTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--IsStaffDesc-->
				<th *ngIf="IsSelected('IsStaffDesc')">
					<p-columnFilter field="IsStaffDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsStaffDesc
								[ngModel]="value"
								[options]="lstIsStaffDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PersonID-->
				<th *ngIf="IsSelected('PersonID')">
					<p-columnFilter type="text" field="PersonID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StudentID-->
				<th *ngIf="IsSelected('StudentID')">
					<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StaffID-->
				<th *ngIf="IsSelected('StaffID')">
					<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StaffTitle-->
				<th *ngIf="IsSelected('StaffTitle')">
					<p-columnFilter field="StaffTitle" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStaffTitle
								[ngModel]="value"
								[options]="lstStaffTitle"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Username-->
				<th *ngIf="IsSelected('Username')">
					<p-columnFilter type="text" field="Username" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th *ngIf="IsSelected('ActiveDesc')">
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--AttendanceStatusDesc-->
				<th *ngIf="IsSelected('AttendanceStatusDesc')">
					<p-columnFilter field="AttendanceStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAttendanceStatusDesc
								[ngModel]="value"
								[options]="lstAttendanceStatusDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--CAASSBarcode-->
				<th *ngIf="IsSelected('CAASSBarcode')">
					<p-columnFilter type="text" field="CAASSBarcode" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--UID-->
				<th *ngIf="IsSelected('UID')">
					<p-columnFilter type="text" field="UID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MTAID-->
				<th *ngIf="IsSelected('MTAID')">
					<p-columnFilter type="text" field="MTAID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--USR1QR-->
				<th *ngIf="IsSelected('USR1QR')">
					<p-columnFilter type="text" field="USR1QR" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--USR2QR-->
				<th *ngIf="IsSelected('USR2QR')">
					<p-columnFilter type="text" field="USR2QR" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SSN-->
				<th *ngIf="IsSelected('SSN')">
					<p-columnFilter type="text" field="SSN" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th *ngIf="IsSelected('Photo')" class="IMGCol" pSortableColumn="HasImageDesc">Photo<p-sortIcon field="HasImageDesc"></p-sortIcon></th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th *ngIf="IsSelected('FirstName')" pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th *ngIf="IsSelected('LastName')" pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th *ngIf="IsSelected('SchoolName')" pSortableColumn="SchoolName">School Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th *ngIf="IsSelected('SchoolNumber')" pSortableColumn="SchoolNumber">School Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th *ngIf="IsSelected('SchoolID')" pSortableColumn="SchoolID">School ID<p-sortIcon field="SchoolID"></p-sortIcon></th>
				<th *ngIf="IsSelected('PersonTypeDesc')" pSortableColumn="PersonTypeDesc">Person Type<p-sortIcon field="PersonTypeDesc"></p-sortIcon></th>
				<th *ngIf="IsSelected('IsStaffDesc')" pSortableColumn="IsStaffDesc">Staff<p-sortIcon field="IsStaffDesc"></p-sortIcon></th>
				<th *ngIf="IsSelected('PersonID')" pSortableColumn="PersonID">Person ID<p-sortIcon field="PersonID"></p-sortIcon></th>
				<th *ngIf="IsSelected('StudentID')" pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th *ngIf="IsSelected('StaffID')" pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
				<th *ngIf="IsSelected('StaffTitle')" pSortableColumn="StaffTitle">Staff Title<p-sortIcon field="StaffTitle"></p-sortIcon></th>
				<th *ngIf="IsSelected('Username')" pSortableColumn="Username">Username<p-sortIcon field="Username"></p-sortIcon></th>
				<th *ngIf="IsSelected('ActiveDesc')" pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th *ngIf="IsSelected('AttendanceStatusDesc')" pSortableColumn="AttendanceStatusDesc">
					Attendance Status<p-sortIcon field="AttendanceStatusDesc"></p-sortIcon>
				</th>
				<th *ngIf="IsSelected('CAASSBarcode')" pSortableColumn="CAASSBarcode">Active CAASS Barcode<p-sortIcon field="CAASSBarcode"></p-sortIcon></th>
				<th *ngIf="IsSelected('UID')" pSortableColumn="UID">Active UID<p-sortIcon field="UID"></p-sortIcon></th>
				<th *ngIf="IsSelected('MTAID')" pSortableColumn="MTAID">Transit Embedded ID<p-sortIcon field="MTAID"></p-sortIcon></th>
				<th *ngIf="IsSelected('USR1QR')" pSortableColumn="USR1QR">QR Code 1<p-sortIcon field="USR1QR"></p-sortIcon></th>
				<th *ngIf="IsSelected('USR2QR')" pSortableColumn="USR2QR">QR Code 2<p-sortIcon field="USR2QR"></p-sortIcon></th>
				<th *ngIf="IsSelected('SSN')" pSortableColumn="SSN">Student SN<p-sortIcon field="SSN"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person" (dblclick)="onRowDblClick(Person)">
				<td class="IMGCol" *ngIf="IsSelected('Photo')">
					<div class="IMGClass">
						<!-- <img class="IMGSize" [src]="Person.PhotoData"> -->

						<img class="IMGSize" [src]="GetPhotoData(Person.PersonPhotoDataID)" />
					</div>
				</td>

				<td *ngFor="let col of GetSelectedCols()" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person[col.Field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
